export async function generateHash(text) {
	const encoder = new TextEncoder()
	const data = encoder.encode(text + new Date().toLocaleDateString('pt-BR') + "127195c7-9190-f8c2cf9bebf7")
	const hashBuffer = await crypto.subtle.digest('SHA-256', data)
	return Array.from(new Uint8Array(hashBuffer))
		.map(b => b.toString(16).padStart(2, '0'))
		.join('')
		.substring(0, 8).toUpperCase()
}